var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("SeaExport.DocumentDelivery"),
            width: "380px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { "label-width": "65px", "label-position": "left" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "custom",
                      attrs: { no: "1" },
                      on: {
                        change: function($event) {
                          return _vm.sendOutCustomTypeChange()
                        }
                      },
                      model: {
                        value: _vm.sendOutDialog.customerType,
                        callback: function($$v) {
                          _vm.$set(_vm.sendOutDialog, "customerType", $$v)
                        },
                        expression: "sendOutDialog.customerType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.bookingParty")))
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.Customer")))
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.CustomsBrokerOthers")))
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.ReceiverCompanyName") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "2" },
                        model: {
                          value: _vm.sendOutDialog.formData.receiveCompany,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.sendOutDialog.formData,
                              "receiveCompany",
                              $$v
                            )
                          },
                          expression: "sendOutDialog.formData.receiveCompany"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Receiver2") } },
                    [
                      _c("el-input", {
                        attrs: { no: "3" },
                        model: {
                          value: _vm.sendOutDialog.formData.receivePerson,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.sendOutDialog.formData,
                              "receivePerson",
                              $$v
                            )
                          },
                          expression: "sendOutDialog.formData.receivePerson"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ReceivingAddress") } },
                    [
                      _c("el-input", {
                        attrs: { no: "4" },
                        model: {
                          value: _vm.sendOutDialog.formData.receiveAddress,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.sendOutDialog.formData,
                              "receiveAddress",
                              $$v
                            )
                          },
                          expression: "sendOutDialog.formData.receiveAddress"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ContactNumber") } },
                    [
                      _c("el-input", {
                        attrs: { no: "5" },
                        model: {
                          value: _vm.sendOutDialog.formData.receiveTel,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.sendOutDialog.formData,
                              "receiveTel",
                              $$v
                            )
                          },
                          expression: "sendOutDialog.formData.receiveTel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_CourierOrderNo") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "6" },
                        model: {
                          value: _vm.sendOutDialog.formData.expressNo,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.sendOutDialog.formData,
                              "expressNo",
                              $$v
                            )
                          },
                          expression: "sendOutDialog.formData.expressNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "7", type: "primary" },
                      on: { click: _vm.sendOutPrint }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "8", type: "primary" },
                      on: { click: _vm.sendOutSend }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Send2")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { no: "9" }, on: { click: _vm.cancel } },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }